"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateProfileRequestSchema = exports.JobPreferenceSchema = exports.WorkHistorySchema = exports.EducationBackgroundSchema = exports.PersonalInfoSchema = exports.UpdateRegistrationRequestSchema = exports.DeleteAccountRequestSchema = exports.ProfileJobPreferencesUpdateRequestSchema = exports.ProfileSelfIntroUpdateRequestSchema = exports.ProfileWorkHistoryUpdateRequestSchema = exports.ProfileExperienceUpdateRequestSchema = exports.ProfilePersonalDetailUpdateRequestSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
const EducationUpdateItemSchema = schemas_1.CandidateEducationSchema.pick({
    fieldOfStudy: true,
    institution: true,
    level: true,
    status: true,
}).extend({
    endDate: schemas_1.ISODateSchema.nullish(),
    startDate: schemas_1.ISODateSchema.nullish(),
});
const LanguageCertificationUpdateSchema = schemas_1.LanguageSkillCertificationSchema.pick({
    certificationId: true,
    score: true,
});
const LanguageSkillUpdateItemSchema = schemas_1.CandidateLanguageSkillSchema.pick({
    communication: true,
    languageId: true,
    reading: true,
    writing: true,
}).extend({ certifications: LanguageCertificationUpdateSchema.array().default([]) });
const QualificationsUpdateSchema = zod_1.z.object({ name: zod_1.z.string().min(1) });
exports.ProfilePersonalDetailUpdateRequestSchema = zod_1.z.object({
    address: zod_1.z
        .object({
        addressLine: zod_1.z.string().min(1).optional(),
        districtId: schemas_1.UUIDSchema.optional(),
        postalCode: zod_1.z.string().min(1).optional(),
        provinceId: schemas_1.UUIDSchema.optional(),
    })
        .optional(),
    contact: zod_1.z
        .object({ phoneNumber: zod_1.z.string().min(1).optional() })
        .optional(),
    educations: EducationUpdateItemSchema.array().optional(),
    languages: LanguageSkillUpdateItemSchema.array().optional(),
    profile: zod_1.z
        .object({
        dateOfBirth: schemas_1.ISODateSchema.nullish(),
        firstName: zod_1.z.string().min(1).optional(),
        gender: schemas_1.GenderEnum.optional(),
        lastName: zod_1.z.string().min(1).optional(),
    })
        .optional(),
    qualifications: QualificationsUpdateSchema.array(),
});
// ******************************************************************************************** //
const ExperienceOccupationItemSchema = schemas_1.CandidateExperienceSchema.pick({
    entityId: true,
    experienceType: true,
    yearOfExperience: true,
});
const ExperienceIndustryItemSchema = schemas_1.CandidateExperienceSchema.pick({
    entityId: true,
    experienceType: true,
    yearOfExperience: true,
});
const SkillItemSchema = schemas_1.CandidateSkillSchema.pick({
    name: true,
    yearOfExperience: true,
});
exports.ProfileExperienceUpdateRequestSchema = zod_1.z.object({
    hasManagementExperience: zod_1.z.boolean().optional(),
    industries: ExperienceIndustryItemSchema.array().optional(),
    itSkills: SkillItemSchema.array().optional(),
    occupations: ExperienceOccupationItemSchema.array().optional(),
    skills: SkillItemSchema.array().optional(),
});
// ******************************************************************************************** //
const WorkHistoryItemSchema = schemas_1.CandidateWorkHistorySchema.pick({
    annualSalary: true,
    companyName: true,
    employmentType: true,
    industryId: true,
    jobDetail: true,
    occupationId: true,
}).extend({
    endDate: schemas_1.ISODateSchema.nullable(),
    isCurrent: zod_1.z.boolean().default(false),
    startDate: schemas_1.ISODateSchema,
});
exports.ProfileWorkHistoryUpdateRequestSchema = zod_1.z.object({
    employmentSummary: zod_1.z.object({
        employmentStatus: schemas_1.EmploymentStatusEnum,
        hideCompanyName: zod_1.z.boolean(),
        jobChangeCount: schemas_1.JobChangeCountEnum.nullable(),
    }),
    histories: WorkHistoryItemSchema.array(),
});
// ******************************************************************************************** //
exports.ProfileSelfIntroUpdateRequestSchema = zod_1.z.object({
    selfIntroduction: zod_1.z.string()
        .trim()
        .min(1)
        .max(2000),
});
// ******************************************************************************************** //
exports.ProfileJobPreferencesUpdateRequestSchema = zod_1.z.object({
    desiredAnnualSalary: zod_1.z.number().int().nonnegative(),
    isOpenToAnyIndustry: zod_1.z.boolean().default(false),
    isOpenToAnyLocation: zod_1.z.boolean().default(false),
    jobSearchStatus: schemas_1.JobSearchStatusEnum,
    preferredIndustries: zod_1.z.string().array().max(3),
    preferredLocations: zod_1.z.string().array().max(3),
    preferredOccupations: zod_1.z.string().array().max(3),
    relocationPreference: schemas_1.RelocationPreferenceEnum,
});
// ******************************************************************************************** //
exports.DeleteAccountRequestSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    message: zod_1.z.string().max(2000).optional(),
    reason: zod_1.z.enum([
        'FOUND_JOB_PLUS_UP',
        'FOUND_JOB_OTHER',
        'STOP_JOB_SEARCH',
        'SITE_DIFFICULT',
        'OTHER',
    ]),
    reasonOther: zod_1.z.string().max(2000).optional(),
    score: zod_1.z.coerce.number().min(1).max(10),
});
// ******************************************************************************************** //
exports.UpdateRegistrationRequestSchema = zod_1.z.object({
    currentEmail: zod_1.z.string().min(1),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    newEmail: zod_1.z.string().email(),
});
// ******************************************************************************************** //
exports.PersonalInfoSchema = zod_1.z.object({
    dateOfBirth: schemas_1.ISODateSchema,
    gender: schemas_1.GenderEnum,
    phoneNumber: zod_1.z.string(),
    provinceId: zod_1.z.string(),
});
exports.EducationBackgroundSchema = zod_1.z.object({
    educationLevel: schemas_1.CandidateEducationSchema.shape.level,
    graduationDate: schemas_1.ISODateSchema.optional(),
    graduationStatus: schemas_1.CandidateEducationSchema.shape.status,
});
exports.WorkHistorySchema = zod_1.z.object({
    companyName: zod_1.z.string(),
    employmentStatus: schemas_1.EmploymentStatusEnum,
    hideCompanyName: zod_1.z.boolean(),
    industryId: schemas_1.UUIDSchema,
    jobChangeCount: schemas_1.JobChangeCountEnum,
    occupationId: schemas_1.UUIDSchema,
});
exports.JobPreferenceSchema = zod_1.z.object({
    currentAnnualSalary: zod_1.z.string(),
    expectedAnnualSalary: zod_1.z.string(),
    openToAnyLocations: zod_1.z.boolean(),
    preferredLocationIds: zod_1.z.array(schemas_1.UUIDSchema),
    preferredOccupationIds: zod_1.z.array(schemas_1.UUIDSchema),
});
exports.UpdateProfileRequestSchema = zod_1.z.object({
    education: exports.EducationBackgroundSchema,
    jobPreference: exports.JobPreferenceSchema,
    personalInfo: exports.PersonalInfoSchema,
    workHistory: exports.WorkHistorySchema,
});
